// agriflow/accounts/static/js/accounts.js
import AccountsLogin from './modules/accountsLogin'
import AccountsCreate from './modules/accountsCreate'
import accountsUpdate from './modules/accountsUpdate'
import passwordReset from './modules/passwordReset';
import deaktiviertAccounts from './modules/accountsDeaktiviert';
import { accountsSettings } from './modules/accountsSettings';

document.addEventListener('DOMContentLoaded', function () {
    const accountslogin = new AccountsLogin();
    const accountscreate = new AccountsCreate();
    const accountsupdate = new accountsUpdate();
    new deaktiviertAccounts();
    

    passwordReset();

    const form = document.getElementById('UserSettingsForm');
    if (form) form.addEventListener('submit', accountsSettings);
});
